"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAILURE = exports.SUCCESS = exports.START = exports.SAGA = void 0;
var SAGA = 'apiFlow/messages/SAGA';
exports.SAGA = SAGA;
var START = 'apiFlow/messages/START';
exports.START = START;
var SUCCESS = 'apiFlow/messages/SUCCESS';
exports.SUCCESS = SUCCESS;
var FAILURE = 'apiFlow/messages/FAILURE';
exports.FAILURE = FAILURE;